'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.toQueryString = toQueryString;
exports.urlQueryJoin = urlQueryJoin;
exports.toAxiosParams = toAxiosParams;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// thanks to http://gitlab.alibaba-inc.com/olympics/request-olympics/blob/master/src/utils.js

function buildParams(prefix, obj, traditional, add) {
    var rbracket = /\[\]$/;

    if (Array.isArray(obj)) {
        // Serialize array item.
        for (var i = 0; obj && i < obj.length; i += 1) {
            var v = obj[i];
            if (traditional || rbracket.test(prefix)) {
                // Treat each array item as a scalar.
                add(prefix, v);
            } else {
                buildParams(prefix + '[' + ((typeof v === 'undefined' ? 'undefined' : (0, _typeof3.default)(v)) === 'object' ? i : '') + ']', v, traditional, add); // eslint-disable-line
            }
        }
    } else if (obj && obj.toString() === '[object Object]') {
        // Serialize object item.
        for (var name in obj) {
            // eslint-disable-line
            buildParams(prefix + '[' + name + ']', obj[name], traditional, add); // eslint-disable-line
        }
    } else {
        // Serialize scalar item.
        add(prefix, obj);
    }
}

/**
 * jsonp 中需要把 data 转换成 query string
 * inspiration from：https://github.com/ded/reqwest/blob/22da21c5de609d5b75ee21eb4484bce42c474973/src/reqwest.js#L552
 */
function toQueryString(o, trad) {
    var traditional = trad || false;
    var s = [];
    var add = function add(key, value) {
        // If value is a function, invoke it and return its value
        value = typeof value === 'function' ? value() : value;
        // fix value为0的情况
        if (!value && value !== 0) {
            value = '';
        }
        // value = value || '';
        s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
    };

    // If an array was passed in, assume that it is an array of form elements.
    if (Array.isArray(o)) {
        for (var i = 0; o && i < o.length; i += 1) {
            add(o[i].name, o[i].value);
        }
    } else {
        // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for (var prefix in o) {
            if (Object.prototype.hasOwnProperty.call(o, prefix)) {
                buildParams(prefix, o[prefix], traditional, add);
            }
        }
    }

    // spaces should be + according to spec
    return s.join('&').replace(/%20/g, '+');
}
// test
/**
 * 拼接有查询参数的 url
 * @param {string} url 传入的 url，可以为空
 * @param {string | object} params 传入的查询参数
 *
 * @returns {string} 拼接好的 url
 */
function urlQueryJoin(url, params) {
    var paramString = typeof params === 'string' ? params : toQueryString(params);
    if (!url) {
        return paramString;
    }
    if (!params) {
        return url;
    }
    var symbol = url.indexOf('?') !== -1 ? '&' : '?';

    return url + (paramString ? symbol + paramString : '');
}

function toAxiosParams(params) {
    var axiosParams = Object.assign({}, params);

    // 将axios的type转化为responseType（axios中的params）
    if (axiosParams.type) {
        axiosParams.responseType = axiosParams.type;
        delete axiosParams.type;
    }

    // 兼容'GET','OPTIONS','HEAD'将请求放在data中的操作（应该放在params中，或直接放在url地址后面）
    var isIgnoreConentType = ['GET', 'OPTIONS', 'HEAD'].indexOf(params.method.toUpperCase()) !== -1;
    if (isIgnoreConentType) {
        axiosParams.params = axiosParams.data;
        delete axiosParams.data;
    }

    // axios没有对Content-Type为application/x-www-form-urlencoded进行处理，需要自己处理
    if (axiosParams.headers['Content-Type'] && axiosParams.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') !== -1 && (0, _typeof3.default)(axiosParams.data) === 'object') {
        axiosParams.data = toQueryString(axiosParams.data);
    }

    return axiosParams;
}